import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'app-midianitas-redirect',
  templateUrl: './midianitas-redirect.component.html',
  styleUrls: ['./midianitas-redirect.component.scss']
})

export class MidianitasRedirectComponent implements OnInit {
  public showText = false;
  private videoPlayer?: HTMLVideoElement;

  @ViewChild('videoPlayer')
  set mainVideoEl(el: ElementRef) {
    this.videoPlayer = el.nativeElement;
    this.play()
  }

  constructor() { }

  ngOnInit() {

  }

  public play() {
    if(this.videoPlayer) {
      this.videoPlayer!.muted = true;
      this.videoPlayer!.play()
    }
  }
}
